<div
  class="attribute-editor-component playlist-item-selector__container scrollable-component-container scrollable-component-settings te-scrollable-container"
>
  <div class="attribute-editor-row playlist-item-selector">
    <ul class="playlist-item-selector__list flex-row flex-wrap">
      @for (component of playlistComponents; track component) {
        @let componentRequiresUpgrade =
          component.requireFeature &&
          !featuresService.isFeatureAvailable(component.requireFeature);

        <li class="align-center hide-empty u_position-relative">
          <a
            role="button"
            [attr.aria-label]="'Add ' + component.title + ' component'"
            class="u_clickable playlist-item-selector__link"
            id="add-{{ component.type }}-button"
            (click)="
              addItem(
                component.type,
                component.options,
                component.requireFeature
              )
            "
            (keyup.enter)="
              addItem(
                component.type,
                component.options,
                component.requireFeature
              )
            "
            (keyup.space)="
              addItem(
                component.type,
                component.options,
                component.requireFeature
              )
            "
            *requireRole="component.requireRole"
          >
            <div class="playlist-item-selector__icon-wrap">
              <mat-icon
                aria-hidden="true"
                [svgIcon]="component.icon"
                class="xlarge"
              ></mat-icon>
            </div>
            <div class="playlist-item-selector__body">
              <div class="playlist-item-selector__title">
                {{ component.title }}
                @if (component.subtitle?.trim()) {
                  <small>{{ component.subtitle }}</small>
                }
              </div>
            </div>
          </a>
          @if (componentRequiresUpgrade) {
            <upgrade-notice
              #UpgradeNotice
              [feature]="component.requireFeature"
              [overlay]="true"
            ></upgrade-notice>
          }
        </li>
      }
    </ul>
  </div>
</div>
